import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

import "../index.css"

import Loading from "../../../common/Loading"
import DispatchNote from './DeliveryChallanList'

import { fetchLogisticPartners } from '../../../services/redux/reducers/commonThunk';


const UpdateTrackingDetailsAndPOD = (props) => {

    const { selectedBuyerPODispatchNotes, dispatchNoteItems, statesList, buyerInvoices, invoiceDispatchMap, handleDeleteDispatchNote } = props
    const [selectedInvoiceDispatchNotesIds, setSelectedInvoiceDispatchNotesIds] = useState([])
    const [reqWiseGroupedDispatchNoteItems, setReqWiseGroupedDispatchNoteItems] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    
    const dispatch = useDispatch()

    const logisticPartners = useSelector(state => state.common.logisticPartners)
    
    useEffect(() => {
        dispatch(fetchLogisticPartners())
    })

    return(
        <div className="py-2">
            {
                selectedBuyerPODispatchNotes?.map(dispatchNote => {
                    let relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === dispatchNote.dispatchNoteId)
                    return (
                        <DispatchNote
                            buyerInvoices={buyerInvoices}
                            dispatchNote={dispatchNote}
                            invoiceDispatchMap={invoiceDispatchMap}
                            selectedInvoiceDispatchNotesIds={selectedInvoiceDispatchNotesIds}
                            dispatchNoteItems={relatedDispatchNoteItems}
                            reqWiseGroupedDispatchNoteItems={reqWiseGroupedDispatchNoteItems}
                            logisticPartners={logisticPartners}
                            statesList={statesList}
                            handleDeleteDispatchNote={handleDeleteDispatchNote}
                        />
                    )
                })
            }
            <Loading visible={isLoading} />
        </div>
    )
}

export default UpdateTrackingDetailsAndPOD